import React from 'react';
import { roadmap } from '../mock';

const Roadmap = () => (
  <section className="px-4 md:px-10 py-20">
    <div className="mx-auto max-w-[1240px]">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-700/30 bg-emerald-100 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-800">
            Roadmap
          </div>
          <h2 className="mt-4 font-serif text-emerald-950 text-4xl md:text-5xl leading-[1.05] tracking-tight max-w-2xl">
            From prototype to a planetary <span className="italic text-emerald-600">network</span>.
          </h2>
        </div>
      </div>

      <div className="mt-14 relative">
        <div className="absolute left-0 right-0 top-6 h-px bg-gradient-to-r from-transparent via-emerald-700/40 to-transparent hidden md:block" />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {roadmap.map((r, i) => (
            <div key={r.year} className="relative">
              <div className="hidden md:flex items-center justify-center absolute left-0 -top-0.5">
                <span className="h-3 w-3 rounded-full bg-emerald-500 ring-4 ring-emerald-500/20" />
              </div>
              <div className="md:pt-10">
                <div className="text-emerald-700 text-sm font-medium">{r.year}</div>
                <div className="mt-1 text-emerald-950 text-xl font-serif">{r.title}</div>
                <p className="mt-2 text-[14px] text-emerald-900/65 leading-relaxed">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Roadmap;
